import HomeTwo from "../components/Home";
import AboutSeven from "../components/AboutPages/AboutSeven";
import Services from "../components/ServicePages/Services";
import Contact from "../components/Contact";
import Blog from "../components/BlogPages/Blog";
import BlogDetails from "../components/BlogPages/BlogDetails";
import PrivacyPolicy from "../components/PrivacyPolicy";
import TermsConditions from "../components/TearmsConditions";
import FourZeroFour from "../components/FourZeroFour";
import SEOcomponent from "../seo/SEOcomponent";
import {
  home,
  about,
  service,
  contact,
  blog,
  blogDetails,
  privacy,
  terms,
  fourZeroFour,
} from "../seo/metaTag";

const componentMap = {
  Home: () => (
    <>
      <SEOcomponent metaTag={home} />
      <HomeTwo />
    </>
  ),
  About: () => (
    <>
      <SEOcomponent metaTag={about} />
      <AboutSeven />
    </>
  ),
  Services: () => (
    <>
      <SEOcomponent metaTag={service} />
      <Services />
    </>
  ),
  Contact: () => (
    <>
      <SEOcomponent metaTag={contact} />
      <Contact />
    </>
  ),
  Blog: () => (
    <>
      <SEOcomponent metaTag={blog} />
      <Blog />
    </>
  ),
  BlogDetails: () => (
    <>
      <SEOcomponent metaTag={blogDetails} />
      <BlogDetails />
    </>
  ),
  PrivacyPolicy: () => (
    <>
      <SEOcomponent metaTag={privacy} />
      <PrivacyPolicy />
    </>
  ),
  TermsConditions: () => (
    <>
      <SEOcomponent metaTag={terms} />
      <TermsConditions />
    </>
  ),
  FourZeroFour: () => (
    <>
      <SEOcomponent metaTag={fourZeroFour} />
      <FourZeroFour />
    </>
  ),
};

export default componentMap;
